import React from 'react'

export default function Filters({ ...props }) {
  return (
    <svg {...props} viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 12H11V10H7V12ZM0 0L0 2H18V0L0 0ZM3 7H15V5H3V7Z" fill='currentColor' />
    </svg>
  )
}
